import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Logo from '../../constants/img/Logo Neutral_Self-declaration02.png';

export default function Summary() {
    const { t } = useTranslation();
    return (
        <div className="box mb-14 md:p-6 md:mt-20 mt-2" style={{ borderRadius: '50px' }}>
            <div className="py-2 md:py-6"></div>

            <div className="flex flex-col md:flex-row md:items-center">
                {/* Logo - Top on mobile, Left on desktop */}
                <div className="w-full md:w-1/2 md:order-1 order-1 text-center md:text-left mb-6 md:mb-0">
                    <img
                        src={Logo}
                        className="w-full max-w-xs md:max-w-sm mx-auto md:mx-0"
                        style={{ marginTop: '0px' }}
                        alt="logo"
                    />
                </div>

                {/* Content - Bottom on mobile, Right on desktop */}
                <div className="w-full md:w-1/2 md:order-2 order-2 md:pl-8">
                    <div className="mb-4">
                        <h1 className="content-header font-bold text-center md:text-left">{t('DOWNLOAD_LOGO_PAGE.HEADER')}</h1>
                    </div>
                    <div className="mb-4 text-center md:text-left">
                        <p>{t('DOWNLOAD_LOGO_PAGE.CONTENT1')}</p>
                        <Trans i18nKey="DOWNLOAD_LOGO_PAGE.CONTENT2"></Trans>
                    </div>
                    <div className="mb-6 text-center md:text-left">
                        <Trans i18nKey="DOWNLOAD_LOGO_PAGE.CONTENT3"></Trans>
                    </div>
                    <a
                        className="button is-large is-fullwidth App mb-4"
                        style={{ backgroundColor: '#26B3F0', fontSize: '16px', color: 'white', height: '70px' }}
                        href={Logo}
                        download
                    >
                        <Trans i18nKey="DOWNLOAD_LOGO_PAGE.BUTTONS.DOWNLOAD"></Trans>
                    </a>
                    <Link to="/">
                        <button className="button is-large is-fullwidth App " style={{ backgroundColor: '#B5D224', fontSize: '20px', height: '70px' }}>
                            {t('DOWNLOAD_LOGO_PAGE.BUTTONS.HOME')}
                        </button>
                    </Link>
                </div>
            </div>

            <div className="py-2 md:py-6 md:mb-8 "></div>
        </div>
    );
}
